export const environment = {
    production: false,
    appVersion: 'v710demo1', //METRONIC
    USERDATA_KEY: 'authf649fc9a5f55', // METRONIC
    isMockEnabled: false, // METRONIC
    apiUrl: 'http://51.79.78.171:7003/', //.NETAPI
    apiUrlG12Connect: {
      donations: 'https://qa.api.g12connect.com/api/v2/donations',
      managment: 'https://qa.api.g12connect.com/api/v2/managment',
      users: 'https://qa.api.g12connect.com/api/v2/users',
      payments: 'https://qa.api.g12connect.com/api/v2/payments',
      paymentsv3: 'https://qa.api.g12connect.com/api/v3/payments',
      reports: 'https://qa.api.g12connect.com/api/v2/reports',
      checkIn: 'https://qa.api.g12connect.com/api/v3/check-in',
    },
    SECRETENCRYPT: 'G12jk5FQg6bu8zWSECURITY#wB9jPyURESPONSE',
    url_response: 'https://qa.mci12.com/g12events/proof-payment',
    url_change_password: 'https://qa.mci12.com/auth/change-password',
    firebaseConfig: {
      apiKey: "AIzaSyDB9T9w2BnOWxI7SbtJuvuEp9lxmM3Xnuw",
      authDomain: "g12-media.firebaseapp.com",
      projectId: "g12-media",
      storageBucket: "g12-media.appspot.com",
      messagingSenderId: "218019509549",
      appId: "1:218019509549:web:8998da7ac9d727c7d5cfa4"
    },
    url_g12_events: 'https://qa.eventosg12.com/home',
    url_donations: 'https://qa.mcidonaciones.com/donations',
    url_api: 'https://9oihqjgmad.execute-api.us-east-2.amazonaws.com/prod/api',
    url_api_wp: 'https://blog.iglesiamci.org/wp-json/wp/v2'
  };
